(function () {
  if (window.__pnpCartDelivery) return;
  window.__pnpCartDelivery = true;

  function show(box, state, text) {
    var result = box.querySelector('[data-pnp-cart-result]');
    if (!result) return;
    result.hidden = false;
    result.dataset.state = state;
    result.textContent = text;
  }

  function run(input, remember) {
    var box = input.closest('.pnp-cart-delivery');
    var D = window.PNPDelivery;
    if (!box || !D) return;
    var r = D.check(input.value);
    if (r.state === 'error') {
      show(box, 'error', 'Enter a UK postcode, for example CV32 7JE.');
      return;
    }
    if (remember) D.save(input.value.trim().toUpperCase());
    if (r.state === 'yes') {
      var t = D.timingText();
      show(box, 'ok', 'Yes, we deliver to ' + r.out + '. ' + t.head + ' ' + t.detail);
    } else {
      show(box, 'no', "Sorry, we don't deliver to " + r.out + '. You can still collect from the shop, or call us on 01926 778188 to check.');
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-pnp-cart-postcode-form]')) return;
    e.preventDefault();
    run(form.querySelector('input'), true);
  });

  function prefill() {
    if (!window.PNPDelivery) return;
    var saved = window.PNPDelivery.saved();
    if (!saved) return;
    document.querySelectorAll('[data-pnp-cart-postcode]').forEach(function (input) {
      if (input.value) return;
      input.value = saved;
      run(input, false);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    prefill();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(prefill, 400);
      });
    }
  });
})();
